import rightImg from "../img/imgg.jpg";
import SEO from "../SEO";
import "./About.css";
import AboutCTA from "./AboutCTA";
import AboutHero from "./AboutHero";
import AboutStory from "./AboutStory";
import AboutValues from "./AboutValues";
import GlobalPresence from "./GlobalPresence";
import HowWeWork from "./HowWeWork";
import OurOffices from "./OurOffices";
import StatsSection from "./StatsSection";

const schemaPackages = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Oglitz Software Pvt Ltd.",
  url: "https://www.oglitz.com",
  logo: "https://www.oglitz.com/static/media/Oglitz-main-icon.6ad376319eba01801745.png",
  description:
    "Oglitz Software Pvt Ltd. delivers innovative software solutions tailored to meet business needs.",
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "Customer Service",
      telephone: "+91-95321-19007",
      email: "info@oglitz.com",
      availableLanguage: "English",
    },
    {
      "@type": "ContactPoint",
      contactType: "Support",
      telephone: "+91-95321-19007",
      email: "support@oglitz.com",
      availableLanguage: "English",
    },
    {
      "@type": "ContactPoint",
      contactType: "WhatsApp",
      telephone: "+91-95321-19007",
      url: "https://wa.me/919532119007",
      availableLanguage: "English",
    },
  ],
  sameAs: [
    "https://www.instagram.com/oglitzsoftware",
    "https://x.com/OglitzSoftware",
    "https://www.linkedin.com/company/oglitz/",
    "https://www.facebook.com/profile.php?id=61565024655930",
  ],
  address: {
    "@type": "PostalAddress",
    streetAddress: "811/78 Yadav Nagar, Ahirwan",
    addressLocality: "Katrisafipur",
    addressRegion: "Kanpur Nagar",
    addressCountry: "IN",
    postalCode: "208007",
  },
  founder: {
    "@type": "Person",
    name: "Ajay Mani Tripathi",
    jobTitle: "Founder and Director",
  },
  about: {
    "@type": "Text",
    text: "Oglitz is more than just a name; it embodies our core values and mission. The name 'Oglitz' is a fusion of O and Glitz: - O: Represents ॐ (OM), symbolizing unity, completeness, and the universal connection of all beings. - Glitz: Signifies brilliance, sophistication, and excellence in the IT industry. Together, Oglitz reflects our commitment to bringing together comprehensive and innovative solutions with a touch of elegance and professionalism. Our name represents our dedication to providing top-notch IT services while fostering a deep understanding and connection with our clients.",
  },
};

const About = () => {
  return (
    <>
      <SEO
        title="About Us | Oglitz Software Pvt Ltd."
        description="Learn more about Oglitz Software Pvt Ltd., a leading IT services company committed to delivering innovative and reliable technology solutions. Discover our values, mission, and the meaning behind our name."
        image={rightImg} // Update with your actual image URL
        url="https://www.oglitz.com/about"
        keywords="Oglitz Software, IT services company, technology solutions, innovative IT solutions, professional IT services, Oglitz Software Pvt Ltd."
        author="Oglitz Software Pvt Ltd."
        schemaData={schemaPackages} // Update with your specific schema data if needed
      />
      <AboutHero />
      <AboutStory />
      <StatsSection />
      <AboutValues />
      <HowWeWork />
      <GlobalPresence />
      <OurOffices />
      <AboutCTA />
    </>
  );
};

export default About;
